import React from 'react'

const StarIcon = ({ filled }: { filled: boolean }) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 1.33334L10.06 5.50668L14.6667 6.18001L11.3333 9.42668L12.12 14.0133L8 11.8467L3.88 14.0133L4.66667 9.42668L1.33333 6.18001L5.94 5.50668L8 1.33334Z"
      fill={filled ? '#FF8214' : '#E5E5E5'}
    />
  </svg>
)

export default StarIcon
